import { authRoles } from 'app/auth';
import ElementTypeTable from './table/ElementTypeTable';
import ElementTypeEditForm from './editform/ElementTypeEditForm';

export default [
	{
		path: '/element-type/edit/:id',
		component: ElementTypeEditForm,
		auth: authRoles.infrastructureElement
	},
	{
		path: '/element-type/:sessionNameParam?',
		component: ElementTypeTable,
		auth: authRoles.infrastructureElement
	}
];
